export default __webpack_public_path__ + "static/media/mapFrame.5b5068ef.png";